/* src/app/modules_v2/booking/locations/components/sections/location-staff-section/location-staff-delete-dialog.component.css */
h2.mat-mdc-dialog-title {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #d32f2f;
}
.warning-icon {
  font-size: 28px;
  width: 28px;
  height: 28px;
  color: #d32f2f;
}
.confirmation-message {
  font-size: 16px;
  margin-bottom: 20px;
  color: #333;
}
.confirmation-message strong {
  color: #d32f2f;
  font-weight: 600;
}
.warning-text {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px;
  background-color: rgba(217, 119, 6, 0.1);
  border-left: 4px solid var(--cf-warning);
  border-radius: 4px;
  font-size: 14px;
  color: #666;
  margin-top: 15px;
}
.warning-text mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: var(--cf-warning);
  margin-top: 2px;
}
mat-dialog-actions,
.mat-mdc-dialog-actions {
  padding: 16px 24px;
  gap: 10px;
}
mat-dialog-content,
.mat-mdc-dialog-content {
  min-width: 400px;
}
@media (max-width: 768px) {
  mat-dialog-content,
  .mat-mdc-dialog-content {
    min-width: auto;
  }
}
/*# sourceMappingURL=location-staff-delete-dialog.component.css.map */
